import { createSlice } from "@reduxjs/toolkit"

export const sizeSlice = createSlice({
  name: "size",
  initialState: {
    sneakerSizeList: [],
    apparelSizeList: [],
    addonSizeList: [],
    sizeList: [],
    exportList: [],
    sizeDetail: {},
    isFreshData: false,
    sneakerTotalEntry: 0,
    apparelTotalEntry: 0,
    addonTotalEntry: 0,
    totalEntry: 0,
    filterTerm: ''
  },
  reducers: {
    setSneakerSizeList: (state, action) => {
      state.sneakerSizeList = action.payload
    },
    setApparelSizeList: (state, action) => {
      state.apparelSizeList = action.payload
    },
    setAddonSizeList: (state, action) => {
      state.addonSizeList = action.payload
    },
    setSizeList: (state, action) => {
      state.sizeList = action.payload
    },
    setExportList: (state, action) => {
      state.exportList = action.payload
    },
    setFilterTerm: (state, action) => {
      state.filterTerm = action.payload
    },
    setFreshList: (state, action) => {
      state.isFreshData = action.payload
    },
    setSneakerTotalEntry: (state, action) => {
      state.sneakerTotalEntry = action.payload
    },
    setApparelTotalEntry: (state, action) => {
      state.apparelTotalEntry = action.payload
    },
    setAddonTotalEntry: (state, action) => {
      state.addonTotalEntry = action.payload
    },
    setTotalEntry: (state, action) => {
      state.totalEntry = action.payload
    },
    setSingleData: (state, action) => {
      state.sizeDetail = action.payload
    }
  }
})

export const {
  setSneakerSizeList,
  setApparelSizeList,
  setAddonSizeList,
  setSizeList,
  setExportList,
  setFilterTerm,
  setSingleData,
  setSneakerTotalEntry,
  setApparelTotalEntry,
  setAddonTotalEntry,
  setTotalEntry,
  setFilteredList,
  setFreshList
} = sizeSlice.actions

export const selectSizeList = (state) => state.size.sizeList
export const selectExportList = (state) => state.size.exportList
export const selectFilterTerm = (state) => state.size.filterTerm
export const selectSneakerTotalEntry = (state) => state.size.sneakerTotalEntry
export const selectApparelTotalEntry = (state) => state.size.apparelTotalEntry
export const selectAddonTotalEntry = (state) => state.size.addonTotalEntry
export const selectTotalEntry = (state) => state.size.totalEntry
export const selectSizeDetail = (state) => state.size.sizeDetail
export const selectFreshData = (state) => state.size.isFreshData

export default sizeSlice.reducer
